<template>
  <v-card class="step-tab-panel" flat>
    <v-row>
      <v-col class="pa-0 step-tab-panel__content justify" />
    </v-row>
  </v-card>
</template>

<script></script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';

.step-tab-panel {
  background-color: $assortment-background !important;

  &__content {
    background: $assortment-panel-background;
  }
}
</style>
